var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPodium3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mount_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 348 131",
    style: {
      enableBackground: "new 0 0 348 131"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.mount3{fill:#ED4490;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "mount3",
    d: "M344.3,96.9c2,6.8,7.4,34.9-0.8,34.9c-9.1,0-22.4-0.2-108.3-0.2c-5.7,0-50.7,0-97.1,0c-5.7,0-87.4-0.2-102.9,0 c-4.3,0-20.1,0.1-35.1,0c0,0,0.4-5.4,0.6-10.7C2,79.5,64.3,22.6,156,3.5C228-11.5,317.7,52.4,344.3,96.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodium3);
export default __webpack_public_path__ + "static/media/podium_3.f05fc96144722eb6e06a9c861a86a88e.svg";
export { ForwardRef as ReactComponent };